import { createFileRoute } from "@tanstack/react-router";
import { AdminSignInPage } from "@/features/auth/AdminSignInPage";
import { requireGuest } from "@/lib/guards";
import { z } from "zod";

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/auth/admin")({
  validateSearch: searchSchema,
  beforeLoad: requireGuest,
  component: AdminSignInPage,
});
